import { IS_LOADING, TOGGLE_MINI_MODE } from '../../utils/constants';

export const toggleLoader = (isLoading = true) => ({
  payload: isLoading,
  type: IS_LOADING,
});

export const toggleMiniMode = (miniMode) => ({
  payload: miniMode,
  type: TOGGLE_MINI_MODE,
});



// WEBPACK FOOTER //
// ./src/modules/app/_actions.js